
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-data-protection",
      function () {
        return require("private-next-pages/contact-data-protection.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-data-protection"])
      });
    }
  